import { convertLanguageToLanguageName, type Language } from './localization'

export const processAiHotlineInstructions = (
  text: string,
  language: Language,
  hasEmergencyNumber: boolean
): string => {
  let processed = text

  processed = processed.replaceAll('{LANGUAGE}', convertLanguageToLanguageName(language))

  if (hasEmergencyNumber) {
    processed = processed
      .replace(/^.*<!-- IF_EMERGENCY_NUMBER_EXISTS -->.*$\n?/gm, '')
      .replace(/^.*<!-- END_IF_EMERGENCY_NUMBER_EXISTS -->.*$\n?/gm, '')
      .replace(
        /^.*<!-- IF_EMERGENCY_NUMBER_MISSING -->.*$\n?[\s\S]*?^.*<!-- END_IF_EMERGENCY_NUMBER_MISSING -->.*$\n?/gm,
        ''
      )
  } else {
    processed = processed
      .replace(
        /^.*<!-- IF_EMERGENCY_NUMBER_EXISTS -->.*$\n?[\s\S]*?^.*<!-- END_IF_EMERGENCY_NUMBER_EXISTS -->.*$\n?/gm,
        ''
      )
      .replace(/^.*<!-- IF_EMERGENCY_NUMBER_MISSING -->.*$\n?/gm, '')
      .replace(/^.*<!-- END_IF_EMERGENCY_NUMBER_MISSING -->.*$\n?/gm, '')
  }

  return processed
}
